// extracted by mini-css-extract-plugin
export var accordion = "faq-module--accordion--30824";
export var accordion_button = "faq-module--accordion_button--c4dda";
export var accordion_heading = "faq-module--accordion_heading--a324f";
export var accordion_item = "faq-module--accordion_item--af211";
export var accordion_panel = "faq-module--accordion_panel--61e57";
export var accordion_wrap = "faq-module--accordion_wrap--629e9";
export var blogfaq = "faq-module--blogfaq--95494";
export var faqTitle = "faq-module--faqTitle--63d3d";
export var faq_left = "faq-module--faq_left--65beb";
export var faq_wrap = "faq-module--faq_wrap--ec6d1";
export var iconFAQ = "faq-module--iconFAQ--86dc9";
export var question_box = "faq-module--question_box--97540";